module.exports = __webpack_public_path__ + "static/img/industries7.967a35c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industries7.png
// module id = HU18
// module chunks = 1